import { PopupTemplate } from "templates/PopupTemplate";
import { Skeleton } from "../../Skeleton";

export function StorePopupSkeleton() {
  return (
    <PopupTemplate
      renderButtons={
        <div>
          <Skeleton width="100%" height="1.6rem" />
          <Skeleton width="100%" height="1.6rem" />
        </div>
      }
      isLoading
    ></PopupTemplate>
  );
}
